module.exports = __webpack_public_path__ + "static/GTEestiProDispTrialRegular-901d3f750b1bb01cac938a55c127fbc4.woff";